import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function DisabledBillingTooltip() {
  return /*#__PURE__*/_jsxs("span", {
    children: ["Billing is disabled for maintenance, please try again later.", /*#__PURE__*/_jsx("br", {}), "For urgent matters please contact support."]
  });
}